import { useSelector, useDispatch } from 'react-redux';
import { ModalType } from '../../app/types';
import { closeModal, exitModal, clickModal } from '../../features/modalSlice';
import AlertModal from './AlertModal';
import DialogText from './DialogText';
import UploadDialog from './UploadDialog';

const ModalRoot = () => {
  const {
    isOpen,
    onCancel = () => {},
    onExited = () => {},
    onClick = () => {},
    isSkipClickModal = false,
    modalType,
    modalProps,
  } = useSelector(state => state.modal);
  const dispatch = useDispatch();
  let ModalComponent = null;

  function handleClick() {
    if (!isSkipClickModal) {
      dispatch(clickModal());
    }
    onClick();
  }

  function handleCancel() {
    dispatch(closeModal());
    onCancel();
  }

  function handleExited() {
    dispatch(exitModal());
    onExited();
  }

  switch (modalType) {
    case ModalType.ALERT_MODAL:
      ModalComponent = AlertModal;
      break;
    case ModalType.DIALOG_TEXT:
      ModalComponent = DialogText;
      break;
    case ModalType.UPLOAD_DIALOG:
      ModalComponent = UploadDialog;
      break;
    default:
  }
  if (!ModalComponent) return null;
  return (
    <ModalComponent
      isOpen={isOpen}
      onCancel={() => handleCancel()}
      onExited={() => handleExited()}
      onClick={() => handleClick()}
      {...modalProps}
    />
  );
};

export default ModalRoot;
